/**
 * @overview 场地统计(预约)
 * @author jzhu
 * @date 2020-8-28
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool } from '../../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool

class SiteAppointmentStatistic extends WizContainer {

    componentName = 'SiteAppointmentStatistic'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig,
            apiDataFormat: {}
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(SiteAppointmentStatistic)
